import { useEffect, useState } from 'react'
import api from '../../services/api'
import {
  Table,
  Button,
  InputGroup,
  FormControl,
  Row,
  Col,
} from 'react-bootstrap'

import moment from 'moment'
import { Container, Paper, TablePagination } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import Alert from '@material-ui/lab/Alert'
import { showToast } from '../../ui-lib/toast'
import 'react-toastify/dist/ReactToastify.css'
import '../Main/Main.css'
import NavBar from '../../components/NavBar/NavBar'
import history from '../../history'
const refreshPage = () => {
  window.location.reload()
}

function MainDashboard() {
  const [body, setBody] = useState([])
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  const getData = async () => {
    await api.get('/pedidos').then((response) => {
      const respost = response.data
      setBody(respost)
    })
  }
  useEffect(() => {
    getData()
  }, [])

  const filteredPedidos = body.filter((pedidos) => {
    return pedidos.name_user.toLowerCase().includes(search.toLocaleLowerCase())
  })

  return (
    <div>
      <NavBar />
      <br />
      <br />
      <div>
        <Container component={Paper} elevation={6}>
          <Row>
            <Col>
              <br />
              <Alert severity="success" color="info">
                Esses são os ultimos 50 pedidos
              </Alert>
              <br />
              <InputGroup className="mb-3">
                <FormControl
                  placeholder="Pesquisar por nome do cliente"
                  aria-label="Pesquisar por nome do cliente"
                  value={search}
                  onChange={(event) => {
                    setSearch(event.target.value)
                  }}
                />
              </InputGroup>

              <Table striped hover responsive variant="dark">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nome</th>
                    <th>Data Entrada</th>
                    <th></th>
                  </tr>
                </thead>
                {filteredPedidos

                  .map((body) => {
                    function handleClick() {
                      history.push('/Pedidos')
                      localStorage.setItem('id', body.id)
                      refreshPage()
                    }
                    function handleDelete() {
                      api
                        .post('pedido/delete?id=' + body.id)
                        .then(() => {
                          showToast({
                            type: 'success',
                            message: 'Pedido deletado com sucesso',
                          })
                          refreshPage()
                        })
                        .catch(() => {
                          showToast({
                            type: 'error',
                            message: 'Não foi possivel deletar o pedido',
                          })
                        })
                    }
                    return (
                      <tbody>
                        <tr>
                          <td onClick={handleClick}>{body.id}</td>
                          <td onClick={handleClick}>{body.name_user}</td>
                          <td onClick={handleClick}>
                            {moment(body.dataAber).format('DD/MM/YYYY')}
                          </td>

                          <td>
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={handleDelete}
                            >
                              {' '}
                              <DeleteIcon fontSize="small" />
                              Deletar
                            </Button>
                          </td>
                        </tr>
                      </tbody>
                    )
                  })
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15, 20]}
                component="div"
                className="Paginador"
                count={body.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
              <br />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default MainDashboard
